import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import HolidaysView from "@/components/holidays";
import { colors } from "@/theme";

export default function DeliveryHolidaysPage() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Simple top bar matching delivery app style */}
      <div
        className="px-5 pt-10 pb-5 rounded-b-3xl shadow-lg"
        style={{ background: colors.brand.gradient }}
      >
        <div className="flex items-center gap-3">
          <button
            onClick={() => navigate(-1)}
            className="w-9 h-9 rounded-full bg-white/15 border border-white/20 flex items-center justify-center text-white"
          >
            <ArrowLeft className="w-4 h-4" />
          </button>
          <h1 className="text-white font-bold text-lg">Holidays</h1>
        </div>
      </div>
      <main className="max-w-7xl mx-auto px-4 py-6">
        <HolidaysView viewOnly />
      </main>
    </div>
  );
}
